module.exports = __webpack_public_path__ + "static/media/02.5656a940.jpg";